import { Stack, Typography, Divider, Avatar, Button, Box } from "@mui/material";
import { getGanZhiColor, getGrey } from "../StyleControl";

function calcDiffMinutes(birthShow, trueSolarTime) {
  const d1 = new Date(birthShow.replace(" ", "T"));
  const d2 = new Date(trueSolarTime.replace(" ", "T"));
  const diff = Math.round((d2.getTime() - d1.getTime()) / 60000);
  if (diff > 0) return `快${diff}分钟`;
  if (diff < 0) return `慢${Math.abs(diff)}分钟`;
  return null;
}

function shortenBirthplace(bp) {
  if (!bp || bp === "北京时间") return "北京时间";
  const parts = bp.split(" ").filter(Boolean);
  if (parts.length <= 2) return bp;
  return parts.slice(-2).join(" ");
}

function formatLng(lng) {
  if (lng === undefined || lng === null) return "";
  return parseFloat(lng).toFixed(2);
}

function getSolarTimeDisplay(birthShow, trueSolarTime) {
  const birthDate = birthShow.split(" ")[0];
  const solarDate = trueSolarTime.split(" ")[0];
  const solarTime = trueSolarTime.split(" ")[1];
  if (solarDate === birthDate) {
    return `真太阳时：${solarTime}`;
  }
  return `真太阳时：${trueSolarTime}`;
}

export default function PersonBaseInfo(obj) {
  const { name, birthShow, riGan, onExport, useTrueSolar, birthplace, longitude, trueSolarTime } = obj;
  const color_sub = getGrey();

  const diffText = useTrueSolar && birthShow && trueSolarTime
    ? calcDiffMinutes(birthShow, trueSolarTime)
    : null;
  const shortPlace = useTrueSolar ? shortenBirthplace(birthplace) : null;
  const lngText = formatLng(longitude);
  const solarDisplay = useTrueSolar && trueSolarTime
    ? getSolarTimeDisplay(birthShow, trueSolarTime)
    : null;

  return (
    <Stack
      direction={"row"}
      alignItems={"center"}
      sx={{ m: 1 }}
    >
      <Stack direction={"row"} alignItems={"center"} spacing={1}>
        <Avatar sx={{ width: 56, height: 56, bgcolor: getGanZhiColor(riGan) }}>
          {riGan}
        </Avatar>

        <Stack
          direction={"column"}
          alignItems={"flex-start"}
          justifyContent={"flex-start"}
        >
          <Typography variant={"h6"} fontWeight={"blod"} color="primary">
            {name}
          </Typography>
          {useTrueSolar && shortPlace && (
            <Typography color={color_sub} fontSize="0.875rem">
              {shortPlace} {lngText ? `${lngText}E` : ""}
            </Typography>
          )}
          {useTrueSolar && solarDisplay && (
            <Typography color={color_sub} fontSize="0.875rem">
              {solarDisplay}
              {diffText ? ` (${diffText})` : ""}
            </Typography>
          )}
          <Typography color={color_sub}>公历：{birthShow}</Typography>
          <Divider></Divider>
        </Stack>
      </Stack>

      {onExport && (
        <Box sx={{ marginLeft: "auto" }}>
          <Button variant="outlined" onClick={onExport}>
            AI指令
          </Button>
        </Box>
      )}
    </Stack>
  );
}
